
// トップページ

import wordpress from '../module/wordpress';

export default function () {

    // WPのjsonを読み込んで表示
    // wordpress();

    // ニュース部分のスクロール
    // $('.js-news-scroll').perfectScrollbar();

    // 背景の位置指定ズーム
    const $resp_img = $('img.js-responsify');
    setTimeout(function () {
        $resp_img.responsify();
    }, 300);
    $(window).on('resize', $.throttle(100, function () {
        $resp_img.responsify();
    }));

}



// WEBPACK FOOTER //
// ./js/page/home.js